export default {
  page_header: {
    title: "Относно",
    description: "На тази страница можете да намерите информация за системата Iris и нейните компоненти.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Общ преглед",
      title: "Добре дошли в Ирис",
      subtitle: "Система за лабораторна свързаност и управление на проби.",
      version_label: "Версия на приложението",
      version_tooltip: "Текуща версия на Iris UI",
      description:
        "Iris е уеб-базирана платформа за лабораторна свързаност, която свързва клинични анализатори с лабораторни информационни системи (LIS). Системата управлява комуникационни канали към апаратите, обработва резултати и насочва пробите през конфигурируем работен поток за валидация преди публикуване.",

      metadata: {
        publisher: "Издател",
        publisher_tooltip: "Софтуерен доставчик, отговорен за Iris",
        license: "Лиценз",
        license_tooltip: "Условия за разпространение на приложението",
        license_value: "Proprietary",
        stack: "Технологии",
        stack_tooltip: "Основни фронтенд технологии, залегнали в основата на Iris",
        stack_value: "Vue 3 / Nuxt 4 / Vuetify 3",
        publisher_value: "SKYWARE Group",
      },

      features: {
        header: "Основни функции:",

        sample_management: {
          title: "Управление на проби",
          subtitle: "Насочва резултатите от апаратите през конфигурируем поток за валидация преди публикуване в LIS",
        },
        real_time_results: {
          title: "Резултати в реално време",
          subtitle: "Получава и визуализира данни от апаратите по TCP канали в реално време",
        },
        multilingual_support: {
          title: "Многоезична поддръжка",
          subtitle: "Превключване между английски, български и македонски от всяка страница",
        },
        secure_authentication: {
          title: "Сигурна автентикация",
          subtitle: "Управление на достъпа по роли чрез OIDC / Keycloak",
        },
        responsive_design: {
          title: "Респонсивен дизайн",
          subtitle: "Оптимизиран за настолни компютри, таблети и мобилни браузъри",
        },
        accessibility: {
          title: "Достъпност",
          subtitle: "Съобразена с WCAG 2.1 AA стандарти",
        },
        high_performance: {
          title: "Висока производителност",
          subtitle: "Реактивен интерфейс, проектиран за времекритични лабораторни процеси",
        },
      },

      targetUsers: {
        header: "За кого е Iris:",

        lab_technicians: {
          title: "Лабораторни техници",
          subtitle:
            "Получават резултати от апаратите, разглеждат чакащи проби и ги одобряват или отхвърлят преди изпращане в LIS",
        },
        pathologists: {
          title: "Патологисти и специалисти",
          subtitle: "Разглеждат и потвърждават резултатни данни, постъпили от свързаните апарати",
        },
        lab_administrators: {
          title: "Администратори на лаборатории",
          subtitle: "Конфигурират апарати, канали и панели и следят работоспособността на системата",
        },
      },
    },

    services_tab: {
      name: "Услуги",
      title: "Системни услуги",
      subtitle: "Версия и работен статус на всяка Iris услуга",

      refresh_button: "Обновяване на услугите",
      refresh_service: "Обновяване",

      fe_description:
        "Уеб интерфейс на Iris. Предоставя управление на апарати, канали и работни потоци за валидация на проби.",
      core_description:
        "Централната сървърна услуга. Управлява апарати, канали, тестове и опашката за валидация на проби. Предоставя REST API, използван от Iris UI.",
      adapter_description:
        "Услугата за интеграция с LIS. Извлича данни за пациенти и назначения от LIS и изпраща потвърдените резултати обратно в LIS.",
    },

    actions_tab: {
      name: "Действия",
      title: "Системни действия",
      subtitle: "Управление на системния кеш и конфигурацията",

      cache_card: {
        title: "Обновяване на кеша на Iris Core",
        content:
          "Изчиства вътрешния кеш на Iris Core и принуждава следващата заявка да презареди всички апарати, канали и конфигурационни данни от базата данни. Използвайте тази функция при остарели данни след директна промяна в базата данни.",
        action: "Обновяване на кеша",
      },
    },

    copyright_tab: {
      name: "Авторски права",
      title: "Авторски права",
      subtitle: "Интелектуална собственост и лицензи",

      description_start: "Всички права на интелектуална собственост на това приложение принадлежат на ",
      description_end:
        ". Правата върху компонентите и библиотеките, използвани в това приложение, принадлежат на техните автори и са лицензирани по подходящ начин, както е описано по-долу.",

      authors_label: "Автори на това приложение",
      authors_value: "Михаил Калъчев, Иван Калъчев",
      developed_by: "Разработено от",
      third_party_header: "Лицензи на трети страни",
      col_component: "Компонент",
      col_license: "Лиценз",
      col_author: "Автор",
    },

    credits_tab: {
      name: "Заслуги",
      title: "Заслуги",
      subtitle: "Изградено с технологии с отворен код",

      application_title: "Iris UI",
      authors_of_application: "Автори на това приложение",
      licence: "лиценз",
      et_al: "и други",
    },
  },
};
